<template lang="pug">
  .page
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Form

    div
      form(@keyup.enter="submit", @submit.prevent="submit")
        div.form-field
          button.button(type="submit") submit

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'BoardSettingsForm',
  data () {
    return {
      form: {}
    }
  },
  computed: {
    ...mapGetters({
    })
  },
  methods: {
    submit () {
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
